export default __webpack_public_path__ + "legacy/static/media/background.995c7249.png";